var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowdownDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.926,
    height: 6.566,
    viewBox: "0 0 11.926 6.566",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.001 60.679) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.288,6.389,59.65,11.75A.6.6,0,1,0,60.5,10.9L55.565,5.964,60.5,1.028A.6.6,0,1,0,59.65.177L54.287,5.538A.608.608,0,0,0,54.288,6.389Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdownDark);
export default __webpack_public_path__ + "static/media/arrowdown-Dark.d2f36d63.svg";
export { ForwardRef as ReactComponent };